<template>
  <div>
    <div style="float:left">
      <vs-chip
        style="cursor:pointer;"
        v-if="filtrosAplicados.length > 0"
        v-on:click.native="setFilters()"
        data-cy="setFilters"
      >
        <vs-avatar icon="search" color="primary" :badge="filtrosAplicados.length"/>
        <strong>Buscar</strong>
      </vs-chip>
      <vs-chip
        style="cursor:pointer;"
        color="gray"
        v-if="!filtrosAplicados.length"
        v-on:click.native="setFilters()"
      >
        <vs-avatar icon="search" color="#ccc"/>
        <strong
        data-cy="search-without-filters"
        >Buscar sin filtros aplicados
      </strong>
      </vs-chip>
      <vs-chip
        :color="colores.navbar"
        v-if="hasQueryFilters"
        style="cursor: context-menu"
        v-on:click.native="clearQueryFilters()"
      >
        <vs-avatar icon="link" color="primary"/>
        <strong>Borrar filtros de enlace</strong>
      </vs-chip>
    </div>
    <div style="float:right;display: flex; align-items: center;">
      <vs-chip
        style="cursor: pointer; margin-left: 10px;"
        color="primary"
        v-tooltip="'Descargar como CSV'"
        data-cy= "download-list"
        v-on:click.native="downloadTray()"
        v-if="mostrarDescarga"
      >
        <vs-avatar color ="primary" icon="file_download"/>
        Descargar
      </vs-chip>
      <vs-dropdown vs-trigger-click data-cy="add-filter">
        <vs-chip color="primary">
          <vs-avatar
            icon="add"
            color="primary"
          />
          Agregar filtro
        </vs-chip>
        <vs-dropdown-menu class="scroll-options" data-cy="list">
          <vs-input
              type="text"
              v-model="search"
              v-if="filtrosDisponibles.length >= showFilterOnNumberElements"
              data-cy="filter-input-search"
          />
          <vs-dropdown-item
            v-for="(filter, index) in avalaibleFiltersSearch"
            :key="`filter-${ index }`"
            v-on:click="addFilter(filter)"
            style="width:200px"
            :data-cy="'filter-'+filter.campo"
          >
            {{ filter.nombre }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <vs-chip
      color="primary" transparent
      v-for="(filtro, index) in filtrosAplicadosFiltered"
      :key="`filtro-aplicado-${ index }`"
      style="cursor: context-menu"
    >
      <vs-avatar
        data-cy="clear"
        icon="clear"
        v-on:click.native="removeFilter(filtro)"
        color="primary"
      />
      <span />
      <div
        v-tooltip="`Modificar filtro ${filtro.nombre}`"
        v-on:click="modificarFiltro(filtro)"
      >
        <strong>{{ filtro.nombre }}: </strong>
        <span class="pl-1">
          {{ filtro.valorFormateado }}
        </span>
      </div>
    </vs-chip>
    <b-modal
      :title="`Filtrar por ${actualFilter.nombre}`"
      ref="configFiltro"
      @cancel="closeModal(actualFilter)"
      @close="closeModal(actualFilter)"
      no-close-on-backdrop
      centered
      hide-footer
      :hide-header-close="editMood"
    >
      <div>
        <div v-if="actualFilter.tipo === 'usuarioIds'">
          <div class="texto-normal">
            <multiselect
              v-model="filterOptions.users"
              select-label="Presiona enter para seleccionar"
              selected-label="Presiona enter para remover"
              deselect-label="Presiona enter para remover"
              placeholder="Seleccione los usuarios"
              label="nombre" track-by="valor"
              :options="actualFilter.opciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                {{ values.length }} usuarios seleccionados</span>
              </template>
              <span slot="noResult">No existen coincidencias</span>
            </multiselect>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'correos'">
          <div class="texto-normal">
            <multiselect
              v-model="filterOptions.userCorreos"
              select-label="Presiona enter para seleccionar"
              selected-label="Presiona enter para remover"
              deselect-label="Presiona enter para remover"
              placeholder="Seleccione los usuarios"
              label="nombre" track-by="valor"
              :options="actualFilter.opciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                {{ values.length }} usuarios seleccionados</span>
              </template>
              <span slot="noResult">No existen coincidencias</span>
            </multiselect>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'derivadoIds'">
          <div class="texto-normal">
            <multiselect
              v-model="filterOptions.derivados"
              select-label="Presiona enter para seleccionar"
              selected-label="Presiona enter para remover"
              deselect-label="Presiona enter para remover"
              placeholder="Seleccione los usuarios"
              label="nombre" track-by="valor"
              :options="actualFilter.opciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                {{ values.length }} usuarios seleccionados</span>
              </template>
              <span slot="noResult">No existen coincidencias</span>
            </multiselect>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'opcionDoc'">
          <div class="texto-normal">
            <multiselect
              v-model="filterOptions.documents"
              select-label="Presiona enter para seleccionar"
              selected-label="Presiona enter para remover"
              deselect-label="Presiona enter para remover"
              placeholder="Seleccione los tipos"
              label="nombre" track-by="valor"
              :options="actualFilter.opciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                {{ values.length }} docs seleccionados</span>
              </template>
              <span slot="noResult">No existen coincidencias</span>
            </multiselect>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'opcionDocRepo'">
          <div class="texto-normal">
            <multiselect
              v-model="filterOptions.documentsDocRepo"
              select-label="Presiona enter para seleccionar"
              selected-label="Presiona enter para remover"
              deselect-label="Presiona enter para remover"
              placeholder="Seleccione los tipos"
              label="nombre" track-by="valor"
              :options="actualFilter.opciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                {{ values.length }} docs seleccionados</span>
              </template>
              <span slot="noResult">No existen coincidencias</span>
            </multiselect>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'opcionInst'">
          <div class="texto-normal">
            <multiselect
              v-model="filterOptions.institutions"
              select-label="Presiona enter para seleccionar"
              selected-label="Presiona enter para remover"
              deselect-label="Presiona enter para remover"
              placeholder="Seleccione los tipos"
              label="nombre" track-by="valor"
              :options="actualFilter.opciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                {{ values.length }} instituciones seleccionados</span>
              </template>
              <span slot="noResult">No existen coincidencias</span>
            </multiselect>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'institutionsDD'">
          <div class="texto-normal">
            <multiselect
              v-model="filterOptions.institutionsDD"
              select-label="Presiona enter para seleccionar"
              selected-label="Presiona enter para remover"
              deselect-label="Presiona enter para remover"
              placeholder="Seleccione los tipos"
              label="nombre" track-by="valor"
              :options="actualFilter.opciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                {{ values.length }} instituciones seleccionados</span>
              </template>
              <span slot="noResult">No existen coincidencias</span>
            </multiselect>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'grupoIds' || actualFilter.tipo === 'oficinaIds'">
          <div class="texto-normal">
            <multiselect
              v-model="filterOptions.groups"
              select-label="Presiona enter para seleccionar"
              selected-label="Presiona enter para remover"
              deselect-label="Presiona enter para remover"
              placeholder="Seleccione los grupos"
              label="nombre" track-by="valor"
              :options="actualFilter.opciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                {{ values.length }} grupos seleccionados</span>
              </template>
              <span slot="noResult">No existen coincidencias</span>
            </multiselect>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'grupoCreador'">
          <div class="texto-normal">
            <multiselect
              v-model="filterOptions.groupCreator"
              select-label="Presiona enter para seleccionar"
              selected-label="Presiona enter para remover"
              deselect-label="Presiona enter para remover"
              placeholder="Seleccione los grupos"
              label="nombre" track-by="valor"
              :options="actualFilter.opciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                {{ values.length }} grupos seleccionados</span>
              </template>
              <span slot="noResult">No existen coincidencias</span>
            </multiselect>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'theme'">
          <div class="texto-normal">
            <multiselect
              v-model="filterOptions.theme"
              select-label="Presiona enter para seleccionar"
              selected-label="Presiona enter para remover"
              deselect-label="Presiona enter para remover"
              placeholder="Seleccione"
              label="nombre" track-by="valor"
              :options="actualFilter.opciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                {{ values.length }} opciones seleccionadas</span>
              </template>
              <span slot="noResult">No existen coincidencias</span>
            </multiselect>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'subTheme'">
          <div class="texto-normal">
            <multiselect
              v-model="filterOptions.subTheme"
              select-label="Presiona enter para seleccionar"
              selected-label="Presiona enter para remover"
              deselect-label="Presiona enter para remover"
              placeholder="Seleccione"
              label="nombre" track-by="valor"
              :options="actualFilter.opciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                {{ values.length }} opciones seleccionadas</span>
              </template>
              <span slot="noResult">No existen coincidencias</span>
            </multiselect>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'grupoDestino'">
          <div class="texto-normal">
            <multiselect
              v-model="filterOptions.groupSubject"
              select-label="Presiona enter para seleccionar"
              selected-label="Presiona enter para remover"
              deselect-label="Presiona enter para remover"
              placeholder="Seleccione los elementos"
              label="nombre" track-by="valor"
              :options="actualFilter.opciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false"
              :preserve-search="true" :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                {{ values.length }} elementos seleccionados</span>
              </template>
              <span slot="noResult">No existen coincidencias</span>
            </multiselect>
          </div>
        </div>
        <div v-if="actualFilter.tipo == 'multi'">
          <div v-if="actualFilter.valor.length==1" class="alerta">
            Debe seleccionar como mínimo 1 de las opciones. Seleccione otra
            opción antes de desmarcar la actual si es que desea cambiarla.
          </div>
          <vs-checkbox
            v-model="selectAllOptions"
            class="modal-opcion"
            v-on:change.native="selectFilter(actualFilter)"
          >
            Seleccionar Todos
          </vs-checkbox>
          <hr/>
          <br/>
          <div
            v-for="[valor, nombre] in Object.entries(actualFilter.opciones)"
            v-bind:key="nombre"
            class="modal-opcion"
          >
            <vs-checkbox
              v-model="actualFilter.valor"
              :vs-value="valor"
              v-on:change.native="selectFilter(actualFilter)"
              :disabled="actualFilter.valor.length === 1 && actualFilter.valor.includes(valor)"
            >
              {{ nombre }}
            </vs-checkbox>
          </div>
        </div>
        <div v-if="actualFilter.tipo== 'texto'">
          <div class="texto-normal">
            <!--<vue-tags-input
              v-model="tag"
              :tags="tags"
              @tags-changed="newTags => tags = newTags"
              placeholder="Agregar"
              :separators="[',']"
            />-->
            <tags-input
              element-id="tags"
              v-model="tags"
              add-tags-on-blur
              add-tags-on-comma
              placeholder="Agregar"
              :typeahead="true"
            />
          </div>
        </div>
        <div v-if="actualFilter.tipo== 'fecha'">
          <div class="texto-normal">
            <datetime
              input-class="input-date"
              v-model="actualFilter.valor"
              :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
              value-zone="local" format="yyyy-MM-dd"
            />
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'rangoFecha'">
          <div class="swtich-tipo-rango">
            <div class="rango-parte">Rango Simple</div>
            <div class="rango-parte rango-switch">
              <vs-switch v-model="tipoRangoFechaAvanzado"/>
            </div>
            <div class="rango-parte">Rango Avanzado</div>
          </div>
          <br/>
          <hr/>
          <br/>
          <div v-if="!tipoRangoFechaAvanzado">
            <div class="center">
              <template
                v-for="(periodo, index) in periodos"
              >
                <vs-button
                  :disabled="periodo.valor === actualFilter.valor"
                  size="medium" color="primary" type="filled"
                  v-on:click="seleccionarRango(periodo.valor)"
                  class="w-full mb-1"
                  :key="`periodo-${index}`"
                >
                  {{ periodo.nombre.charAt(0).toUpperCase() + periodo.nombre.slice(1) }} <br/>
                  <span style="font-size: 80%">
                  (desde el {{ formatoTipoRango(periodo.valor, true) }} hasta hoy)
                </span>
                </vs-button>
              </template>
            </div>
          </div>
          <div v-if="tipoRangoFechaAvanzado">
            entre el
            <datetime
              v-model="rangoAvanzado.desde"
              input-class="input-date"
              :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
              value-zone="local" format="yyyy-MM-dd"
              data-cy="start-time"
            />
            y el
            <datetime
              v-model="rangoAvanzado.hasta"
              input-class="input-date" :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
              value-zone="local"
              format="yyyy-MM-dd"
              data-cy="end-time"
            />
          </div>
        </div>
      </div>
      <div class="text-center mt-2">
        <vs-button size="small" v-on:click="verificarFiltrosAlCerrar" >
          Confirmar
        </vs-button>
      </div>
    </b-modal>
  </div>
</template>
<script>

import Multiselect from 'vue-multiselect';
import { mapGetters, mapState } from 'vuex';
import Vue from 'vue';

import { downloadTrays } from '@/febos/servicios/api/busqueda.api';
import Themes from '@/febos/chile/dnt/components/wizard/companies/61808000-5/utils/Themes';
import RepositoriesCustomTypeMixin from '@/febos/chile/commons/mixins/RepositoriesCustomTypeMixin';
import { GORE_VALPARAISO } from '@/constants/companies';

export default {
  name: 'FiltrosLettyDnt',
  components: {
    Multiselect
  },
  mixins: [
    RepositoriesCustomTypeMixin
  ],
  props: {
    filtersView: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      required: false
    },
    groups: {
      type: Array,
      required: false
    },
    documents: {
      type: Array,
      required: false
    },
    institutions: {
      type: Array,
      required: false
    },
    institutionsDD: {
      type: Array,
      required: false
    },
    periodos: {
      type: Array,
      required: false
    },
    hasQueryFilters: {
      type: Boolean,
      default: false
    },
    clearQueryFilters: {
      type: Function
    },
    showFilterOnNumberElements: {
      type: Number,
      default: 7
    }
  },
  data() {
    return {
      themes: Themes.map((item) => item.tema).flat()
        .map((mappedItem) => ({ valor: mappedItem.id, nombre: mappedItem.label }))
        .sort(({ nombre: a }, { nombre: b }) => a.localeCompare(b)),
      subThemes: Themes
        .reduce((subtemas, item) => {
          item.subtema.forEach((subtema) => {
            if (!subtemas.find((existingSubtema) => existingSubtema.label === subtema.label)) {
              subtemas.push(subtema);
            }
          });
          return subtemas;
        }, [])
        .map((mappedItem) => ({ valor: mappedItem.id, nombre: mappedItem.label }))
        .sort(({ nombre: a }, { nombre: b }) => a.localeCompare(b)),
      search: '',
      editMood: false,
      modalFilter: false,
      actualFilter: {},
      filtrosAplicados: [],
      filtrosDisponibles: [],
      selectAllOptions: false,
      tipoRangoFechaAvanzado: false,
      tipoRango: false,
      fechaSimpleActual: '',
      rangoAvanzado: {
        desde: '',
        hasta: ''
      },
      tag: '',
      tags: [],
      filterOptions: {
        users: [],
        userCorreos: [],
        derivados: [],
        documents: [],
        documentsDocRepo: [],
        correos: [],
        institutions: [],
        institutionsDD: [],
        groups: [],
        groupCreator: [],
        theme: [],
        subTheme: [],
        groupSubject: []
      },
      mostrarDescarga: this.verificarRuta()
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'actualFilter.valor': function (nuevoValor) {
      if (this.actualFilter.tipo === 'fecha') {
        this.actualFilter.valor = Vue.moment(nuevoValor).format('YYYY-MM-DD');
        this.actualFilter.valorFormateado = Vue.moment(nuevoValor).format('YYYY-MM-DD');
      }
    },
    // eslint-disable-next-line func-names
    'actualFilter.valorFormateado': function (nuevoValor) {
      this.actualFilter.valorFormateado = nuevoValor;
    },
    // eslint-disable-next-line func-names
    'filterOptions.users': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((user) => user.valor);
      this.actualFilter.valorFormateado = valorNuevo.map((user) => user.nombre).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.derivados': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((user) => user.valor);
      this.actualFilter.valorFormateado = valorNuevo.map((user) => user.nombre).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.userCorreos': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((user) => user.valor);
      this.actualFilter.valorFormateado = valorNuevo.map((user) => user.nombre).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.documents': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((document) => document.valor);
      this.actualFilter.valorFormateado = valorNuevo.map((document) => document.nombre).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.documentsDocRepo': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((document) => document.valor);
      this.actualFilter.valorFormateado = valorNuevo.map((document) => document.nombre).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.institutions': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((inst) => inst.valor);
      this.actualFilter.valorFormateado = valorNuevo.map((inst) => inst.nombre).join(',');
    },
    'filterOptions.institutionsDD': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((inst) => inst.valor);
      this.actualFilter.valorFormateado = valorNuevo.map((inst) => inst.nombre).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.groups': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((group) => group.valor);
      this.actualFilter.valorFormateado = valorNuevo.map((group) => group.nombre).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.groupCreator': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((group) => group.valor);
      this.actualFilter.valorFormateado = valorNuevo.map((group) => group.nombre).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.theme': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((theme) => theme.valor);
      this.actualFilter.valorFormateado = valorNuevo.map((theme) => theme.nombre).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.subTheme': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((subTheme) => subTheme.valor);
      this.actualFilter.valorFormateado = valorNuevo.map((subTheme) => subTheme.nombre).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.groupSubject': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((group) => group.valor);
      this.actualFilter.valorFormateado = valorNuevo.map((group) => group.nombre).join(',');
    },
    rangoAvanzado: {
      handler(valor) {
        this.$log.debug('watch.rangoAvanzado');
        this.$log.info('valor rango avanzado', valor);
        try {
          const desde = valor.desde.split('T')[0];
          const hasta = valor.hasta.split('T')[0];
          this.actualFilter.valor = `${desde}--${hasta}`;
        } catch (e) {
          this.$log.info('Una de las fechas de rango avanzado no esta correctamente '
            + 'formateada,se necesitan ambas para setear el valor del filtro');
        }
        this.seleccionarRango(this.actualFilter.valor);
      },
      deep: true
    },
    tipoRangoFechaAvanzado() {
      if (!this.actualFilter.valor.includes('--') && !this.actualFilter.valor.includes(' ')) {
        this.rangoAvanzado.desde = this.formatoTipoRango(this.actualFilter.valor);
        this.rangoAvanzado.hasta = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
        this.actualFilter.valor = `${this.rangoAvanzado.desde }--${ this.rangoAvanzado.hasta}`;
        // this.seleccionarRango(this.actualFilter.valor);
      } else {
        const [desde, hasta] = this.actualFilter.valor.split('--');
        this.rangoAvanzado.desde = desde;
        this.rangoAvanzado.hasta = hasta;
      }
    },
    tags(valorNuevo) {
      const valor = valorNuevo;
      this.actualFilter.valor = valor.map((tag) => tag.value); // .join(",");
      this.actualFilter.valorFormateado = valor.map((tag) => tag.value).join(', ');

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: valor.map((tag) => tag.value).join(','),
            valorFormateado: valor.map((tag) => tag.value).join(', ')
          };
        }
        return filterApplied;
      });
    },
    selectAllOptions(valorNuevo) {
      if (valorNuevo === true) {
        if (this.actualFilter.valor.length !== Object.keys(this.actualFilter.opciones).length) {
          this.actualFilter.valor = Object.keys(this.actualFilter.opciones);
          this.actualFilter.valorFormateado = Object.values(this.actualFilter.opciones);
        }
      } else {
        this.actualFilter.valor = [];
        this.actualFilter.valorFormateado = [];
      }
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapState('Personalizacion', {
      colores: (state) => state.colores
    }),
    filtrosAplicadosFiltered() {
      return this.filtrosAplicados.filter((filtro) => filtro.valor !== '');
    },
    avalaibleFiltersSearch() {
      if (this.search && this.search.length > 1) {
        return Object.values(this.filtrosDisponibles)
          .filter((filtro) => filtro.nombre.toLowerCase().includes(this.search.toLowerCase()));
      }
      return this.filtrosDisponibles;
    }
  },
  methods: {
    clearOptions() {
      this.tag = '';
      this.tags = [];
    },
    async downloadTray() {
      this.$bvToast.toast(
        'Se está descargando su archivo',
        {
          title: '¡Danos unos segundos!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      const grandParent = this.$parent.$parent;
      // Reemplaza filtros
      let filtros = grandParent.filters;
      filtros = filtros.replace(/bandejaTipo:[^|]*\|?/, '');
      filtros += `${filtros.endsWith('|') ? '' : '|'}iutEmpresa:${this.company.id}|app:ED`;
      try {
        const payload = {
          params: {
            filtros,
            orden: '-fechaCreacion',
            formato: 'csv',
            extension: 'os'
          }
        };
        const response = await downloadTrays(payload);
        window.open(response.data.url, '_blank');
      } finally {
        this.loading = false;
      }
    },
    verificarRuta() {
      return this.$route.path.includes('cloud/aprobaciones/general');
    },
    removeFilter(filter) {
      this.filtrosAplicados = this.filtrosAplicados
        .filter((filterApplied) => filterApplied.campo !== filter.campo);
      switch (filter.tipo) {
        case 'usuarioIds': {
          this.filterOptions.users = [];
          break;
        }
        case 'derivadoIds': {
          this.filterOptions.derivados = [];
          break;
        }
        case 'opcionInst': {
          this.filterOptions.institutions = [];
          break;
        }
        case 'institutionsDD': {
          this.filterOptions.institutionsDD = [];
          break;
        }
        case 'opcionDoc': {
          this.filterOptions.documents = [];
          break;
        }
        case 'opcionDocRepo': {
          this.filterOptions.documentsDocRepo = [];
          break;
        }
        case 'grupoIds': {
          this.filterOptions.groups = [];
          break;
        }
        case 'oficinaIds': {
          this.filterOptions.groups = [];
          break;
        }
        case 'grupoCreador': {
          this.filterOptions.groupCreator = [];
          break;
        }
        case 'grupoDestino': {
          this.filterOptions.groupSubject = [];
          break;
        }
        case 'theme': {
          this.filterOptions.theme = [];
          break;
        }
        case 'subTheme': {
          this.filterOptions.subTheme = [];
          break;
        }
        case 'correos': {
          this.filterOptions.userCorreos = [];
          break;
        }
        case 'multi': {
          this.selectAllOptions = false;
          break;
        }
        default: {
          console.log('format filtro default', this.actualFilter);
        }
      }
    },
    formatoTipoRango(formato, humano = false) {
      const estilo = humano ? 'LL' : 'YYYY-MM-DD';
      switch (formato) {
        case 'ultimas4semanas':
          return Vue.moment().subtract(28, 'days').format(estilo);
        case 'esteMes':
          return Vue.moment().startOf('month').format(estilo);
        case 'esteMesConAnterior':
          return Vue.moment().subtract(1, 'month').startOf('month').format(estilo);
        case 'ultimos3meses':
          return Vue.moment().subtract(2, 'month').startOf('month').format(estilo);
        case 'ultimos6meses':
          return Vue.moment().subtract(5, 'month').startOf('month').format(estilo);
        default:
          return Vue.moment().subtract(5, 'month').startOf('month').format(estilo);
      }
    },
    formatRangeDate() {
      if (this.actualFilter.valor.includes('--')) {
        const [desde, hasta] = this.actualFilter.valor.split('--');
        this.actualFilter.valorFormateado = `${desde} al ${hasta}`;
      } else {
        const foundPeriod = this.periodosDisponibles
          .find((period) => period.valor === this.actualFilter.valor);
        this.actualFilter.valorFormateado = foundPeriod.nombre;
      }
    },
    seleccionarRango(valor) {
      if (valor === 'personalizado') {
        this.tipoRangoFechaAvanzado = true;
        this.actualFilter.valor = valor;
      } else {
        this.actualFilter.valor = valor;
        this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
          if (filterApplied.campo === this.actualFilter.campo) {
            return {
              ...filterApplied,
              valor,
              valorFormateado: this.formatRangeDate()
            };
          }
          return filterApplied;
        });
      }
      console.log('rango seleccionado', this.filtrosAplicados);
    },
    modificarFiltro(filter) {
      // this.clearOptions();
      this.editMood = true;
      this.actualFilter = filter;
      if (this.actualFilter.tipo === 'rangoFecha') {
        if (this.actualFilter.valor.includes('--')) {
          this.tipoRangoFechaAvanzado = true;
          const [desde, hasta] = filter.valor.split('--');
          this.rangoAvanzado.desde = desde;
          this.rangoAvanzado.hasta = hasta;
        } else {
          this.tipoRangoFechaAvanzado = false;
        }
      } else if (this.actualFilter.tipo === 'numero' || this.actualFilter.tipo === 'texto') {
        this.tags = this.actualFilter.valor.map((valor) => ({ value: valor }));
        this.tipoRango = this.actualFilter.valor.includes('--');
      }

      this.actualFilter.valor = filter.valor;
      this.$refs.configFiltro.show();
    },
    seleccionarTodos() {
      this.actualFilter.valor = Object.keys(this.actualFilter.opciones);
    },
    closeModal(filter) {
      this.removeFilter(filter);
      this.editMood = false;
    },
    verificarFiltrosAlCerrar() {
      console.log('verificarFiltrosAlCerrar');
      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: this.actualFilter.valor,
            valorFormateado: this.actualFilter.valorFormateado
          };
        }
        return filterApplied;
      }).filter((filter) => filter.valor.length > 0 && filter.valor !== '');

      // this.actualFilter = {};
      this.$refs.configFiltro.hide();
      this.editMood = false;
    },
    setFilters(onMounted = false) {
      const query = [];
      // para los filtros
      (this.filtersView.filtrosFijos || []).forEach((filter) => {
        let { valor } = filter;
        // eslint-disable-next-line no-template-curly-in-string
        if (valor === '${iutEmpresa}') {
          // eslint-disable-next-line no-template-curly-in-string
          valor = valor.replace('${iutEmpresa}', this.company.iut);
        }
        // eslint-disable-next-line no-template-curly-in-string
        if (valor === '${empresaId}') {
          // eslint-disable-next-line no-template-curly-in-string
          valor = valor.replace('${empresaId}', this.company.id);
        }
        // eslint-disable-next-line no-template-curly-in-string
        if (valor === '${correoUsuario}') {
          // eslint-disable-next-line no-template-curly-in-string
          valor = valor.replace('${correoUsuario}', this.currentUser.correo);
        }
        // eslint-disable-next-line no-template-curly-in-string
        if (valor === '${idUsuario}') {
          // eslint-disable-next-line no-template-curly-in-string
          valor = valor.replace('${idUsuario}', this.currentUser.id);
          valor = valor.concat(',--grupos--');
        }
        if (filter.tipo === 'multi') {
          valor = Object.keys(filter.opciones);
        }
        query.push(`${ filter.campo }:${ valor}`);
      });

      // para los filtros disponibles que fueron aplicados

      this.filtrosAplicados.forEach((filter) => {
        if (filter.tipo === 'rangoFecha' && !filter.valor.includes('--')) {
          const inicio = this.formatoTipoRango(filter.valor);
          const fin = Vue.moment().format('YYYY-MM-DD');
          query.push(`${filter.campo}:${inicio}--${fin}`);
        } else if (filter.valor.length > 0 && filter.valor !== '') {
          query.push(`${ filter.campo }:${ filter.valor }`);
        }
      });

      this.$emit('filtros-aplicados', query.join('|'), onMounted);
    },
    searchAvailableFilters() {
      let { filtrosHabilitados } = this.filtersView;

      filtrosHabilitados = (filtrosHabilitados || [])
        .sort(({ nombre: a }, { nombre: b }) => a.localeCompare(b));
      this.filtrosDisponibles = [...filtrosHabilitados];
    },
    setOptionsFilter(addedFilter) {
      let opciones = [];
      switch (addedFilter.tipo) {
        case 'usuarioIds': {
          opciones = this.users.map((user) => {
            const userOption = {
              nombre: user.nombre,
              valor: user.id
            };
            return userOption;
          });
          break;
        }
        case 'derivadoIds': {
          opciones = this.users.map((user) => {
            const userOption = {
              nombre: user.nombre,
              valor: user.id
            };
            return userOption;
          });
          break;
        }
        case 'opcionInst': {
          opciones = this.institutions.map((institution) => {
            const institutionOption = {
              nombre: institution.label,
              valor: institution.value
            };
            return institutionOption;
          });
          break;
        }
        case 'institutionsDD': {
          opciones = this.institutionsDD.map((institution) => {
            const institutionOption = {
              nombre: institution.label,
              valor: institution.value
            };
            return institutionOption;
          });
          break;
        }
        case 'theme': {
          opciones = this.themes;
          break;
        }
        case 'subTheme': {
          opciones = this.subThemes;
          break;
        }
        case 'opcionDoc': {
          opciones = this.documents.map((document) => {
            const documentOption = {
              nombre: document.groupId.includes('.item') ? document.label : `${document.label} (todos)`,
              valor: document.value
            };
            return documentOption;
          });
          break;
        }
        case 'opcionDocRepo': {
          const replacement = {};
          if (this.company.iut === GORE_VALPARAISO.iut) {
            // Se cambia por valores usados en docDigital
            // tabla: opciones, grupo_id: opciones-gore-custom
            replacement.MEMO = 'MEM';
            replacement.RES = 'RES-A';
            replacement.RESUGDPS = 'RES-EX';
          }

          opciones = this.optionsTypeDocument.map((document) => {
            const val = Object.keys(replacement)
              .find((name) => name === document.value) && replacement[document.value];

            return {
              nombre: document.text,
              valor: val || document.value
            };
          });
          break;
        }
        case 'grupoCreador':
        case 'grupoDestino':
        case 'grupoIds': {
          opciones = this.groups
            .filter((groupFilter) => groupFilter.esOficina === 'no' || groupFilter.esOficina === 'N'
              || !groupFilter.isOffice)
            .map((group) => {
              const groupOption = {
                nombre: group.nombre,
                valor: group.id
              };
              return groupOption;
            });
          break;
        }
        case 'oficinaIds': {
          opciones = this.groups
            .filter((groupFilter) => groupFilter.esOficina === 'si' || groupFilter.esOficina === 'Y'
              || groupFilter.isOffice)
            .map((group) => {
              const groupOption = {
                nombre: group.nombre,
                valor: group.id
              };
              return groupOption;
            });
          break;
        }
        case 'correos': {
          opciones = this.users.map((user) => {
            const userOption = {
              nombre: user.nombre,
              valor: user.correo
            };
            return userOption;
          });
          break;
        }
        default: {
          console.log('format filtro default', this.actualFilter);
        }
      }
      return opciones;
    },
    addFilter(filter) {
      this.actualFilter = {};
      this.clearOptions();

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === filter.campo) {
          return {
            ...filterApplied,
            valor: filter.valor,
            valorFormateado: filter.valorFormateado
          };
        }
        return filterApplied;
      }).filter((filter2) => filter2.valor.length > 0 && filter2.valor !== '');

      const isApplied = this.filtrosAplicados
        .some((filterApplied) => filterApplied.campo === filter.campo);

      if (isApplied) {
        return;
      }

      this.actualFilter = filter;
      const addedFilter = filter;
      switch (addedFilter.tipo) {
        case 'usuarioIds': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'derivadoIds': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'opcionInst': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'opcionDocRepo':
        case 'opcionDoc': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'grupoIds': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'oficinaIds': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'grupoCreador': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'theme': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'subTheme': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'correos': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'grupoDestino': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'institutionsDD': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'multi': {
          this.selectAllOptions = false;
          break;
        }
        default: {
          console.log('format filtro default', this.actualFilter);
        }
      }
      this.filtrosAplicados.push(addedFilter);
      this.$refs.configFiltro.show();
    },
    selectFilter(filter) {
      this.actualFilter.valorFormateado = filter.valor
        .map((valor) => this.actualFilter.opciones[valor])
        .join(', ');

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === filter.campo) {
          return {
            ...filterApplied,
            valorFormateado: this.actualFilter.valorFormateado,
            valor: filter.valor
          };
        }
        return filterApplied;
      });
      if (this.actualFilter.valor.length === Object.keys(this.actualFilter.opciones).length) {
        this.selectAllOptions = true;
      }
    }
  },
  mounted() {
    this.periodosDisponibles = this.periodos?.filter((periodo) => periodo.valor !== 'personalizado') || [];
    this.searchAvailableFilters();
    this.setFilters(true);
  }
};

</script>
<style>
.input-date {
  border: 1px solid #bcbcbc;
  padding: 6px 8px;
  border-radius: 5px;
}

.scroll-options {
  max-height: 400px;
  overflow-y: scroll;
}
</style>
